export const environment = {
    production: false,
    environmentName: 'development',
    authApiUrl: 'https://dev-identity-api.relaxedcoder.com',
    //authApiUrl: 'https://localhost:44361',
    apiUrl: 'https://dev-spendkeep-api.relaxedcoder.com',
    //apiUrl: 'https://localhost:44362',
    appUrl: 'https://dev-spendkeep.relaxedcoder.com',
    applicationId: 'a9a957ea-7c4d-431c-abc9-3c2e567e48c5',
    captchaSiteKey: '0x4AAAAAAA76OxW-GS2TcUrI',
    googleLoginKey: '398550446888-4l01h7akvsji5k5ahktg3rmahbhgduas.apps.googleusercontent.com',
};
